import React from "react";

const Loading = () => {

    return (
        <div className='loading'>
            <h2>CARGANDO...</h2>
            <img src="../img/loading.gif" alt="Loading..."/>
        </div>
    )
}

export default Loading